<div class="dog">

  <div class="head normal">

    <div class="ear-left"></div>
    <div class="ear-right"></div>
  </div>

  <div class="buddy-koerper"></div>
  <div class="tail waggle-exited">
  </div>

  <app-hearts></app-hearts>

</div>
